import React, { useEffect, useState } from "react";
import {
  BackButton,
  Box,
  ButtonStyled,
  FormElementWrapper,
  LabelStyled,
  NotAuthorizedForResource,
  SeparatorBorder,
  SpanStyled,
  SubHeadingStyled,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { useNavigate, useParams } from "react-router-dom";
import { AddCabinetWrapper } from "./styled";
import { useTranslation } from "react-i18next";
import { ContentWrapper } from "../../../components/styled/styled";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useForm } from "react-hook-form";
import {
  DateIcon,
  MenuTriggerCross,
  PlaceholderImg,
  Plus,
  SingleProfile,
  TimeSquare,
} from "../../../components/styled/AllImages";
import FormRadio from "../../../components/common/radioButtons/FormRadio";
import styled from "styled-components";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import { Form } from "react-bootstrap";
import CabinetsApi from "../../../services/api/cabinetsApi";
import ValidationErrorText from "../../../components/common/inputFields/ValidationErrorText";
import { toast } from "react-toastify";
import AddMultipleUsers from "../../../components/common/modals/multipleUsersModal/AddMultipleUsers";
import AddSingleDepartment from "../../../components/common/modals/singleDepartmentModal/AddSingleDepartment";
import AddMultipleDepartments from "../../../components/common/modals/multipleDepartmentsModal/AddMultipleDepartments";
import { useSelector } from "react-redux";
import ValidationController from "../../../components/common/inputFields/ValidationController";
import RequestsApi from "../../../services/api/requestsApi";
import CustomRadioButton from "../../../components/common/radioButtons/CustomRadio";
import TimeOnlyPicker from "../../../components/common/inputFields/TimePicker";
import DatePickerRightIcon from "../../../components/common/inputFields/DatePickerRightIcon";
import {
  formatTimeToFull,
  reqFormatDate,
  toUTCISOStringFromDateTime,
} from "../../../utils";
import AddMultipleUsersBranchDep from "./components/AddMultiUsersBranchDep";

const ASSET_URL = process.env.REACT_APP_ASSET_URL;

const EditTemporaryCabinet = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { usersList, branchesDeps, hqBranchesList } = useSelector(
    (state) => state.helper
  );
  const { id } = useParams();
  const navigate = useNavigate();

  const [accessDenied, setAccessDenied] = useState(false);
  const [selectedIds, setSelectedIds] = useState(null);
  const [cabinId, setCabinId] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [accessThroughRequest, setAccessThroughRequest] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [radioOptions, setRadioOptions] = useState([]);
  const [isTemporary, setIsTemporary] = useState(null);
  const [defaultDateTime, setDefaultDateTime] = useState(null);
  const [userSelections, setUserSelections] = useState({
    branch_ids: [],
    department_ids: [],
    user_ids: [],
  });
  const [checkedUsers, setCheckedUsers] = useState([]);
  const [checkedHqBranches, setCheckedHqBranches] = useState({});
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    resetField,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      selected_ids: checkedUsers?.map((user) => user.id) || [],
    },
  });

  const checkSelectedValueID = watch("setting_id");

  const fromDate = watch("from_date");
  const tillDate = watch("till_date");
  const fromTime = watch("from_time");

  const filterTimeFrom = (time) => {
    if (!fromDate) return false;
    const now = new Date();
    const selectedDate = new Date(fromDate);
    const isToday =
      selectedDate.getDate() === now.getDate() &&
      selectedDate.getMonth() === now.getMonth() &&
      selectedDate.getFullYear() === now.getFullYear();

    if (isToday) {
      return time.getTime() >= now.getTime();
    }

    return true;
  };

  const filterTimeTill = (time) => {
    if (!tillDate || !fromDate) return false;

    const selectedFromDate = new Date(fromDate);
    const selectedTillDate = new Date(tillDate);
    const selectedFromTime = new Date(fromTime);

    const isSameDate =
      selectedFromDate.getDate() === selectedTillDate.getDate() &&
      selectedFromDate.getMonth() === selectedTillDate.getMonth() &&
      selectedFromDate.getFullYear() === selectedTillDate.getFullYear();

    // If from_date === till_date, disable times earlier than from_time
    if (isSameDate) {
      return time.getTime() >= selectedFromTime.getTime();
    }

    // If till_date is today, only allow future times from now
    const now = new Date();
    const isTillToday =
      selectedTillDate.getDate() === now.getDate() &&
      selectedTillDate.getMonth() === now.getMonth() &&
      selectedTillDate.getFullYear() === now.getFullYear();

    if (isTillToday) {
      return time.getTime() >= now.getTime();
    }

    return true;
  };

  const isDisabledFrom = !fromDate;
  const isDisabledTill = !tillDate;

  const getEndOfDay = (date) => {
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    return end;
  };
  const getStartOfDay = (date) => {
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    return start;
  };

  const now = new Date();
  const minTimeTill = (() => {
    if (!tillDate || !fromDate || !fromTime) return now;

    const selectedTill = new Date(tillDate);
    const selectedFrom = new Date(fromDate);
    const selectedFromTime = new Date(fromTime);

    const isSameDate =
      selectedFrom.getDate() === selectedTill.getDate() &&
      selectedFrom.getMonth() === selectedTill.getMonth() &&
      selectedFrom.getFullYear() === selectedTill.getFullYear();

    if (isSameDate) {
      return selectedFromTime;
    }

    const isToday =
      selectedTill.getDate() === now.getDate() &&
      selectedTill.getMonth() === now.getMonth() &&
      selectedTill.getFullYear() === now.getFullYear();

    return isToday ? now : getStartOfDay(selectedTill);
  })();

  const maxTime = tillDate ? getEndOfDay(new Date(tillDate)) : getEndOfDay(now);

  const isFromDateValid = !!fromDate && !isNaN(new Date(fromDate).getTime());
  const isFromTimeValid = !!fromTime && !isNaN(new Date(fromTime).getTime());

  const isTillDisabled = !(isFromDateValid && isFromTimeValid);

  const handleSingleSelect = (id) => {
    if (id) {
      setSelectedIds([id]);
    } else {
      setSelectedIds(null);
    }
  };

  const validateSelection = (value) => {
    if (
      [4, 5, 8, 9].includes(Number(checkSelectedValueID)) &&
      (!value || value.length === 0)
    ) {
      return t("Please_select_user");
    }
    if ([6, 7].includes(Number(checkSelectedValueID)) && !value) {
      return t("Please_select_department");
    }
    return true;
  };

  const getRadioData = async () => {
    try {
      setDataLoading(true);
      const response = await CabinetsApi.addCabinetRadio();

      if (response?.data?.length > 1) {
        const filteredOptions = response.data.slice(1);

        setRadioOptions([
          ...filteredOptions.map((option) => {
            if (option.id == 7 || option.id == 8) {
              return { ...option, description: "" };
            } else if (option.id == 6) {
              return {
                ...option,
                description: t("only_open_to_one_department_description"),
              };
            } else if (
              option.id == 2 ||
              option.id == 3 ||
              option.id == 4 ||
              option.id == 5
            ) {
              return {
                ...option,
                description: t("cabinet_settings_description"),
              };
            }
            return option;
          }),
        ]);
      }
    } catch (error) {
    } finally {
      setDataLoading(false);
    }
  };
  useEffect(() => {
    getRadioData();
  }, [language]);

  const handleRemoveRequest = async (id) => {
    try {
      const { code, message } = await RequestsApi.removeRequest({ id });
      if (code === 200) {
        setAccessThroughRequest(
          accessThroughRequest.filter((item) => item.id != id)
        );
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {}
  };

  const getSingleCabinet = async () => {
    try {
      setAccessDenied(false);
      setLoading(true);
      const response = await CabinetsApi.getSingleCabinet(id);
      if (response.code === 200) {
        if (response?.data) {
          const formattedCheckedUsers =
            response?.data?.cabinet?.cabinet_detail?.selected_users_data?.map(
              (item) => ({
                ...item,
                subLabel:
                  language === "en"
                    ? `${item?.user_detail?.department_selective?.name_en} (${item?.user_detail?.office_location_selective?.name_en})`
                    : `${item?.user_detail?.department_selective?.name_ar} (${item?.user_detail?.office_location_selective?.name_ar})`,
              })
            );
          setCheckedUsers(formattedCheckedUsers);

          const from_branches =
            response?.data?.cabinet?.cabinet_detail?.from_branches || [];
          const from_departments =
            response?.data?.cabinet?.cabinet_detail?.from_departments || [];

          setCheckedHqBranches({
            branchIds: from_branches,
            depIds: from_departments,
          });

          const combineDateTime = (dateStr, timeStr) => {
            return new Date(`${dateStr}T${timeStr}`);
          };
          const startDateTimeLocal = new Date(
            response?.data?.cabinet?.time_limit_start
          );
          const endDateTimeLocal = new Date(
            response?.data?.cabinet?.time_limit_end
          );
          const startDateTime = new Date(
            response?.data?.cabinet?.time_limit_start
          );
          const endDateTime = new Date(response?.data?.cabinet?.time_limit_end);

          // Optional: Extract date and time parts as strings
          const fromDateStr = startDateTime.toISOString().split("T")[0]; // e.g., "2025-05-20"
          const fromTimeStr = startDateTime.toTimeString().split(" ")[0]; // e.g., "11:42:00"
          const tillDateStr = endDateTime.toISOString().split("T")[0]; // e.g., "2025-05-20"
          const tillTimeStr = endDateTime.toTimeString().split(" ")[0];

          const fromDate = combineDateTime(fromDateStr, fromTimeStr);
          const tillDate = combineDateTime(tillDateStr, tillTimeStr);

          console.log(fromDate, tillDate);

          setIsTemporary(1);

          reset({
            id: response?.data?.cabinet?.id,
            cabinet_name: response?.data?.cabinet?.name || "",
            description: response?.data?.cabinet?.description || "",
            setting_id: response?.data?.cabinet?.setting_id || "",
            from_date: fromDate || null,
            from_time: fromDate || null,
            till_date: tillDate || null,
            till_time: tillDate || null,
            selected_ids:
              response?.data?.cabinet?.setting_id === 4 ||
              response?.data?.cabinet?.setting_id === 5
                ? response?.data?.cabinet?.cabinet_detail?.selected_users
                : response?.data?.cabinet?.cabinet_detail?.selected_departments,
          });
          setFilteredUsers(
            usersList?.filter(
              (usr) =>
                usr?.user_detail?.department_id ==
                response?.data?.cabinet?.current_owner_department_id
            )
          );
          setCabinId(response?.data?.cabinet?.id);
          setAccessThroughRequest(
            response?.data?.cabinet?.access_granted_requests.map((item) => ({
              ...item,
              profile: item?.from_user?.profile
                ? `${ASSET_URL}/${item?.from_user?.profile}`
                : null,
            }))
          );

          setSelectedIds(
            response?.data?.cabinet?.setting_id === 4 ||
              response?.data?.cabinet?.setting_id === 5
              ? response?.data?.cabinet?.cabinet_detail?.selected_users
              : response?.data?.cabinet?.cabinet_detail?.selected_departments
          );
        }
      }
      if (response.code === 403) {
        setAccessDenied(true);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (formData) => {
    const updatedData = {
      ...formData,
      action: "update",
      cabinet_id: cabinId,
      selected_ids: selectedIds,
      is_temporary: isTemporary && isTemporary,
      from_branches: userSelections.branch_ids,
      from_departments: userSelections.department_ids,
      // time_limit_start:
      //   parseInt(isTemporary) === 1
      //     ? `${reqFormatDate(formData?.from_date)} ${formatTimeToFull(
      //         formData?.from_time
      //       )}`
      //     : null,
      // time_limit_end:
      //   parseInt(isTemporary) === 1
      //     ? `${reqFormatDate(formData?.till_date)} ${formatTimeToFull(
      //         formData?.till_time
      //       )}`
      //     : null,
      time_limit_start:
        parseInt(isTemporary) === 1
          ? toUTCISOStringFromDateTime(formData?.from_date, formData?.from_time)
          : null,

      time_limit_end:
        parseInt(isTemporary) === 1
          ? toUTCISOStringFromDateTime(formData?.till_date, formData?.till_time)
          : null,
    };
    try {
      setSubmitLoading(true);
      const response = await CabinetsApi.createCabinet(updatedData);
      if (response.code === 200) {
        toast.success(t("cabinet_updated"));
        reset();
        navigate("/temporary-cabinets");
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
    } catch (error) {
    } finally {
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getSingleCabinet();
    }
  }, [id]);

  useEffect(() => {
    if (checkedUsers?.length > 0 && !getValues("selected_ids")?.length) {
      const userIds = checkedUsers.map((user) => user.id);
      setValue("selected_ids", userIds);
      setSelectedIds(userIds); // if you're syncing this too
    }
  }, [checkedUsers]);

  return (
    <AddCabinetWrapper>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box className="content-head">
          <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
            <BackButton
              label={t("edit_temporary_cabinet")}
              onClick={() => navigate("/temporary-cabinets")}
            />
            <Breadcrumbs />
          </Box>
        </Box>
        {accessDenied ? (
          <NotAuthorizedForResource />
        ) : (
          <ContentWrapper>
            {loading ? (
              <Box className="p-5 m-5">
                <ThemeLoader />
              </Box>
            ) : (
              <>
                <Box>
                  <ValidatedInput
                    name="cabinet_name"
                    type="input"
                    fieldType="text"
                    placeholder={"cabinet_name"}
                    label="cabinet_name"
                    staric={true}
                    register={register}
                    errors={errors}
                    validationRules={{
                      required: true,
                    }}
                    className={"border-0"}
                  />

                  <ValidatedInput
                    name="description"
                    label="Description"
                    type="textarea"
                    placeholder={"Description"}
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: false,
                    }}
                  />
                </Box>

                <Box>
                  <Box>
                    <SubHeadingStyled
                      size="15px"
                      weight={700}
                      color={"var(--text)"}
                      className="px-4 pt-4 pb-0"
                    >
                      {t("valid_from")}
                    </SubHeadingStyled>
                    <Box className="info-item gap-2 d-flex align-items-center py-4 px-4 px-lg-4 w-100 formEleContainer me-2">
                      <p className="date-label">{t("date")}</p>
                      <Box className="w-100">
                        <DatePickerRightIcon
                          name={"from_date"}
                          type={"input"}
                          placeholder={t("date")}
                          icon={DateIcon}
                          control={control}
                          errors={errors}
                          rules={{ required: true }}
                          yearDropdown={true}
                          monthDropdown={true}
                          minDate={new Date()}
                          // minDate={new Date()}
                          bg="var(--bgSecondary)"
                          icon_position="right"
                        />
                      </Box>
                    </Box>

                    <Box>
                      <TimeOnlyPicker
                        name="from_time"
                        control={control}
                        label="Pick Time"
                        rules={{ required: true }}
                        bg="var(--bgSecondary)"
                        icon={TimeSquare}
                        errors={errors}
                        fromDate={fromDate}
                        isDisabledFrom={isDisabledFrom}
                        filterTimeFrom={filterTimeFrom}
                      />
                    </Box>
                  </Box>
                  <SeparatorBorder className="mt-2" />
                  <Box>
                    <SubHeadingStyled
                      size="15px"
                      weight={700}
                      color={"var(--text)"}
                      className="px-4 pt-4 pb-0"
                    >
                      {t("valid_till")}
                    </SubHeadingStyled>
                    <Box className="info-item gap-2 d-flex align-items-center py-4 px-4 px-lg-4 w-100 formEleContainer me-2">
                      <p className="date-label">{t("date")}</p>
                      <Box className="w-100">
                        <DatePickerRightIcon
                          name={"till_date"}
                          type={"input"}
                          placeholder={t("date")}
                          icon={DateIcon}
                          control={control}
                          errors={errors}
                          rules={{ required: true }}
                          yearDropdown={true}
                          monthDropdown={true}
                          minDate={fromDate}
                          // minDate={new Date()}
                          bg="var(--bgSecondary)"
                          icon_position="right"
                        />
                      </Box>
                    </Box>

                    <Box>
                      <TimeOnlyPicker
                        name="till_time"
                        control={control}
                        label="Pick Time"
                        rules={{ required: true }}
                        bg="var(--bgSecondary)"
                        icon={TimeSquare}
                        errors={errors}
                        tillDate={tillDate}
                        isDisabledTill={isDisabledTill}
                        filterTimeTill={filterTimeTill}
                        minTime={minTimeTill}
                        maxTime={maxTime}
                        disabled={isDisabledTill || isTillDisabled}
                      />
                    </Box>
                  </Box>
                  <Box className="d-flex justify-content-end">
                    <Box className="p-4 d-flex gap-3">
                      <ButtonStyled
                        label={t("Cancel")}
                        bg={"var(--bgSecondary)"}
                        color={"var(--text2)"}
                        type="button"
                        onClick={() => navigate("/temporary-cabinets")}
                      />
                      <ButtonStyled
                        label={t("Update")}
                        type="submit"
                        isLoading={submitLoading}
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </ContentWrapper>
        )}
      </Form>
    </AddCabinetWrapper>
  );
};

export default EditTemporaryCabinet;

const UserUpload = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  padding: 8px 16px;
  background-color: var(--bgSecondary);
  border-radius: 10px;
  width: fit-content;
  .userPlaceholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    max-width: 30px;
    height: 30px;
    background-color: var(--greyBg);
    border-radius: 50%;
    // border: 1px dashed var(--greyText);
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  svg.removeTaskTrigger {
    width: 12px;
    height: 12px;
    margin-left: 7px;
    &:hover {
      stroke: var(--redColor);
      fill: var(--redColor);
      path {
        stroke: var(--redColor);
        fill: var(--redColor);
      }
    }
  }
  input[type="file"] {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .abtUser {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    span {
      // width: 100%;
    }
  }
`;
